module.exports = __webpack_public_path__ + "img/crown2.84930fee.png";